export const CHANGE_THEME_EVENT = 'igc-change-theme';
